<div [ngClass]="{'short-message': true, 'has-notify': !!conversation.status}">
  <div class="shimmer" (click)="onSelect($event)">
    <div class="notify" *ngIf="conversation.isSelected"></div>
    <div class="content" [ngClass]="{'unread-message': hasWarning(conversation)}">
      <div class="title">{{getConversationName(conversation)}}</div>
      <div class="summary">{{lastMessage(conversation)}}</div>
    </div>
  </div>
  <div class="remove-icon" *ngIf="canDelete">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 22 22" (click)="onDelete($event)">
      <path d="M2.516.307a1.5 1.5 0 0 0-1.063.44l-.707.706a1.502 1.502 0 0 0 0 2.123L8.17 11 .746 18.424a1.502 1.502 0 0 0 0 2.123l.707.707a1.502 1.502 0 0 0 2.123 0L11 13.83l7.424 7.424a1.502 1.502 0 0 0 2.123 0l.707-.707a1.502 1.502 0 0 0 0-2.123L13.83 11l7.424-7.424a1.502 1.502 0 0 0 0-2.123l-.707-.707a1.502 1.502 0 0 0-2.123 0L11 8.17 3.576.746a1.495 1.495 0 0 0-1.06-.44z" fill="#95a0b1" fill-rule="evenodd"/>
    </svg>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/conversation-item/conversation-item.component.html